/**
 * External dependencies
 */
import { HeaderIcon } from '~cartzillagb/icons'
import {
	disabledBlocks,
	i18n,
	srcUrl
} from 'cartzillagb'

import {
	createButtonAttributes,
	range
} from '~cartzillagb/util'

import DefaultYTImage  from  './img/yt-logo.png'
import DefaultImage  from  './img/img1.png'
import DefaultImage1  from  './img/img2.jpg'


/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'

export const schema = {
	enableContainer: {
		type: 'boolean',
		default: true,
	},

	enableSubscriberImages: {
		type: 'boolean',
		default: true,
	},

	enableSubscriberCount: {
		type: 'boolean',
		default: true,
	},

	enableButton: {
		type: 'boolean',
		default: true,
	},

	enableVideoTitle: {
		type: 'boolean',
		default: true,
	},

	subscriberCount: {
		type: 'string',
	},

	text: {
		type: 'string',
	},

	enableBadge: {
		type: 'boolean',
		default: true,
	},


	lgColumns : {
		type: 'number',
		default: 3,
	},

	limit: {
		type: 'number',
		default: 4,
	},

	// Title.
	showTitle: {
		type: 'boolean',
		default: true,
	},

	title: {
		type: 'string',
		default: __( 'Title for This Block', i18n ),
	},

	titleTag: {
		type: 'string',
	},

	// Header Button.
	showHeaderButton: {
		type: 'boolean',
		default: true,
	},

	...createButtonAttributes( 'headerButton%s', {
		defaultText: 'More videos',
		defaultIcon: 'czi-arrow-right',
		defaultSize: 'sm',
		defaultDesign: 'outline',
		backgroundColor: 'accent',
		iconAfterText: true,
	} ),

	mediaURL : {
		type: 'string',
		default: `${ srcUrl }/${ DefaultYTImage }`
	},

	mediaURL1 : {
		type: 'string',
		default: `${ srcUrl }/${ DefaultImage1 }`
	},



	...createButtonAttributes( 'button1%s', {
		defaultText: 'Subscribe',
		defaultSize: 'sm',
		backgroundColor: 'primary',
		defaultIcon: 'czi-add-user',
    } ),

}

const maxLimit = applyFilters( 'cartzillagb.youtube-feed-block.edit.inspector.max.limit', 4 )

{ range( 1, maxLimit + 1 ).forEach( i => {

	schema[ `imageURL${ i }` ] = {
		type: 'string',
		default: `${ srcUrl }/${ DefaultImage }`
	}
	schema[ `badge${ i }` ] = {
		type: 'string',

	}
	schema[ `videoTitle${ i }` ] = {
        type: 'string',
    }
    schema[ `link${ i }` ] = {
        type: 'string',
    }
} ) }

export const name = 'czgb/youtube-feed-block'

export const settings = {
	title: __( 'YouTube Feed Block', i18n ),
	icon: HeaderIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	description: __( 'Display a YouTube Feed like block in your website. ', i18n ),
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}
